(() => {
  function init(scope = document) {
    const frames = [...scope.querySelectorAll('[data-vt3-widget-auto-height]')];
    if (scope.matches?.('[data-vt3-widget-auto-height]')) frames.unshift(scope);
    frames.forEach(frame => {
      if (frame.voltestAutoHeight) return;
      const expectedOrigin = new URL(frame.src, window.location.href).origin;
      const resize = event => {
        if (event.source !== frame.contentWindow || event.origin !== expectedOrigin) return;
        const data = event.data;
        if (!data || data.type !== 'voltest:resize') return;
        const height = Number(data.height);
        if (!Number.isFinite(height) || height < 0 || height > 10000) return;
        frame.style.height = `${Math.ceil(height)}px`;
        frame.setAttribute('data-vt3-widget-height', '');
      };
      window.addEventListener('message', resize);
      frame.voltestAutoHeight = {destroy() {window.removeEventListener('message', resize);}};
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vt3-widget-auto-height]').forEach(frame => {
      frame.voltestAutoHeight?.destroy();delete frame.voltestAutoHeight;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
